module.exports = __webpack_public_path__ + "static/etiqa-tick-781265d9d9b4942532f286d75e7eb9cf.png";